export default {"src":"/_next/static/media/magnify.b698c5cb.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};